"use client";

import * as S from "./styles.ts";
import NumberPickerTabs from "@template/blocks/NumberPickerSection/component/NumberPickerTabs";
import { P, UniversalLink } from "@template/components";
import TransfersInCart from "@template/blocks/NumberTransferSection/component/TransfersInCart";
import ArchStandaloneSectionComponent from "@template/blocks/ArchStandaloneSection/component";

const DisclaimerCard = () => (
  <S.Disclaimer>
    <P>
      To make the phone number transfer process as quick and easy as possible,
      we require that you provide documentation to prove you currently own the
      number. Documentation can be emailed to us directly or sent via a form
      from your account dashboard.
    </P>
    <UniversalLink
      href="/faq/phone-numbers/transfer-requirements/"
      title="Find out what a transfer requires"
      styled
    >
      What do I need to provide in order to transfer my number to Yay.com?
    </UniversalLink>
  </S.Disclaimer>
);

const NumberTransfer = ({ altStyling = false }: { altStyling?: boolean }) => {
  return (
    <S.NumberTransferSectionWrapper $altStyling={altStyling}>
      {altStyling && (
        <ArchStandaloneSectionComponent
          color="white"
          background="dark"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
          }}
        />
      )}

      <S.NumberTransferSectionContainer>
        <NumberPickerTabs defaultKey="transfer" />
        <DisclaimerCard />
        <TransfersInCart />
      </S.NumberTransferSectionContainer>
    </S.NumberTransferSectionWrapper>
  );
};

export default NumberTransfer;

export const options = [
  {
    description: "",
    displayName: "NumberTransfer",
    methods: [],
    props: {
      altStyling: {
        required: false,
        flowType: { name: "boolean" },
        description: "",
        defaultValue: { value: "false", computed: false },
      },
    },
  },
];
